module.exports = __webpack_public_path__ + "static/lsc2021-silver-88a830e118290cbcbdaa5f4fc5e5fd71.png";